<template>
  <notifications
    :width="width"
    :position="position"
    :duration="duration"
    :max="max"
    :group="group"
    :type="type"
    :classes="classes"
    :animation-type="animationType"
    :animation-name="animationName"
    :animation="animation"
    :speed="speed"
    :reverse="reverse"
    :ignoreDuplicates="ignoreDuplicates"
    :closeOnClick="closeOnClick"
  >
    <template v-slot:body="props">
      <div class="vue-notification__text">{{ props.item.text }}</div>
      <lego-icon
        color-reverse
        class="vue-notification__close-btn"
        iconType="df"
        icon="delete_24"
        :size="24"
        @click="props.close"
      />
    </template>
  </notifications>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '600px'
    },
    position: {
      type: String,
      default: 'bottom top'
    },
    duration: {
      type: Number,
      default: 5000
    },
    speed: { type: Number, default: 300 } // Speed of animation showing/hiding
  }
};
</script>
<style lang="scss" scoped>
:deep .vue-notification {
  &__close-btn {
    opacity: 0.6;
  }
  &-wrapper {
    align-items: flex-start;
  }
}
</style>
